import store from '../store';
import { apiServices } from '../services/api.services';
import errorsHandled from '../../variables/errorsHandled';
import { toast } from 'react-toastify';
import i18n from '../../i18n';

export const storageEnterEditMode = (id) => {
    return async (Dispatch) => {
      Dispatch({type: 'STORAGE_ENTER_EDIT', id});
    };
}

export const storageCancelEditMode = (id) => {
    return async (Dispatch) => {
      Dispatch({type: 'STORAGE_CANCEL_EDIT', id});
    };
}

export const storageConfirmEdit = (id, name, isCalculator) => {
    var storages = store.getState().devices.storages;
    const index = storages.findIndex((s) => s.id === id);
    var edited = true;
    if (index === -1) return;
    if (storages[index].name === name && storages[index].isCalculator === isCalculator) 
      edited = false;
    if (!edited) return;
    const args = {
      id,
      name,
      isCalculator: isCalculator.toString()
    };
    apiServices.post("/updateDevice", args).then((res) => {
      if (res && res.data) {
        if (res.data.success) store.dispatch({type: 'STORAGE_EDIT_UPDATE', id});
        if (res.data.error && res.data.code) {
          if (errorsHandled.includes(res.data.code)) {
            if (res.data.code === "9002" || res.data.code === "9003" || res.data.code === "9004") {
              apiServices.refreshServersAndDevices();
              toast.info(i18n.t(`devices:error:wrongDevice`));
            } else toast.error(i18n.t(`devices:error:${res.data.code}`));
          }
        }
      } else store.dispatch({type: 'STORAGE_EDIT_RESET', id});
    }).catch(err => {
      return store.dispatch({type: 'STORAGE_EDIT_RESET', id});;
    });
};


export const storageDelete = (id) => {
    return async (Dispatch) => {
        var args = {id};
        await apiServices.post("/deleteDevice", args).then((res) => {
            Dispatch({type: 'STORAGE_DELETE', id});
        }).catch(err => {
            return err;
        });   
    };
};

const features = [
  {
    key: 'isCalculator',
    plan: 3
  }
];

const deviceName = /^[\p{L} \-\d]{0,24}$/u;
export const storagePreEdit = (id, part, value) => {
    var userPlan = store.getState().infos.vip.plan;
    const found = features.findIndex(f => f.key === part);
    if (found > -1) {
      if (userPlan < features[found].plan) {
        // send notif
        return;
      }
    }
    if (!deviceName.test(value)) {
      return;
    }
    return async (Dispatch) => {
        Dispatch({type: 'STORAGE_PRE_EDIT', id, part, value});
        if (["isCalculator"].includes(part)) {
          var devices = store.getState().devices.storages;
          const index = devices.findIndex((d) => d.id === id);
          storageConfirmEdit(id, devices[index].edit.name, devices[index].edit.isCalculator);
        }
    }
}